import { Notification } from 'modules/core/domain/interfaces/supabase/notifications/types';
import { getLastReadNotificationId } from './notifications';

export const hasNewNotifications = (notifications: Notification[]): boolean => {
  if (!notifications.length) return false;
  const lastReadId = getLastReadNotificationId();
  // Если пользователь ещё ни разу не помечал уведомления прочитанными, считаем все новые
  if (lastReadId === null) return true;
  const newestId = notifications.reduce((max, n) => (n.id > max ? n.id : max), notifications[0].id);
  return newestId > lastReadId;
};
